import { SelectChallengeResult } from '@varo/graphql-schema-types';
import SelectChallenge from 'services/graphql/mutations/SelectChallenge';
import useCancellableMutation from 'shared/hooks/useCancellableMutation';

const useSelectChallengeGql = () => {
  const [result, executeMutation] = useCancellableMutation<{
    selectChallenge: SelectChallengeResult;
  }>(SelectChallenge);

  const selectChallenge = (challengeId: string) => {
    return executeMutation({ challengeId });
  };

  return {
    selectChallengeResult: result.data?.selectChallenge,
    fetching: result.fetching,
    error: result.error,
    selectChallenge,
  };
};

export default useSelectChallengeGql;
